<template>
  <template v-if="hasRequiredPermissions">
    <slot />
  </template>
  <BaseCard
    v-else
    class="flex min-h-64 flex-col items-center justify-center p-8 text-center"
  >
    <IconExclamationTriangle
      class="mb-4 size-12 text-primary"
    />
    <h2
      class="mb-2 text-xl font-semibold text-background-fg/87"
    >
      You don't have permission to access this page.
    </h2>
    <RouterLink
      #default="{ href, navigate }"
      :to="fallbackRoutePath"
      custom
    >
      <ActionButton as="a" :href="href" @click="navigate">
        Return to {{ fallbackRouteTitle }}
      </ActionButton>
    </RouterLink>
  </BaseCard>
</template>

<script setup lang="ts">
import type { UserPermission } from "@/services/auth/retrieveCurrentUser"
import type { RouteNamedMap } from "@/router/RouteNamedMap"

const props = defineProps<{
  permission: UserPermission | ReadonlyArray<UserPermission>
  fallbackRouteName: keyof RouteNamedMap
}>()

const router = useRouter()
const { hasRequiredPermissions } = useRequiredPermissions(
  toRef(props, "permission")
)

const fallbackRoute = computed(() =>
  router
    .getRoutes()
    .find((route) => route.name === props.fallbackRouteName)
)

const fallbackRouteTitle = computed(() => {
  return (
    fallbackRoute.value?.meta.pageTitle || "previous page"
  )
})

const fallbackRoutePath = computed(
  () => fallbackRoute.value?.path || "/"
)
</script>
